import React, { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import { toast } from "sonner";
import { fetchBlobUrl, downloadFile } from "@/lib/marketing";

export const AssetTile = ({ asset, basePath }) => {
  const [src, setSrc] = useState(null);
  const path = `${basePath}/${asset.id}`;

  useEffect(() => {
    if (asset.kind !== "image") return undefined;
    let url;
    fetchBlobUrl(path).then((u) => { url = u; setSrc(u); }).catch(() => {});
    return () => url && URL.revokeObjectURL(url);
  }, [path, asset.kind]);

  const download = () =>
    downloadFile(path, asset.filename).then(() => toast.success("Download avviato")).catch(() => toast.error("Download non riuscito"));

  return (
    <div className="border border-gray-200 rounded-[10px] overflow-hidden bg-white" data-testid={`asset-${asset.id}`}>
      <div className="h-32 bg-[#F5F5F5] flex items-center justify-center">
        {asset.kind === "image" && src ? (
          <img src={src} alt={asset.filename} className="h-full w-full object-cover" />
        ) : (
          <FileText size={30} className="text-gray-400" />
        )}
      </div>
      <div className="flex items-center justify-between gap-2 p-2">
        <span className="text-xs text-gray-600 truncate" title={asset.filename}>{asset.filename}</span>
        <button onClick={download} className="text-[#B40101] hover:opacity-70 transition-opacity" data-testid={`asset-download-${asset.id}`} title="Scarica">
          <Download size={15} />
        </button>
      </div>
    </div>
  );
};
